import {
  IconArrowLeft,
  Link,
  Masthead,
  Typography,
  bodySmallTypography,
  handleImgSrcError,
  neutral60,
} from '@leaftrade/leaftrade-component-library';
import React from 'react';
import { useDispatch } from 'react-redux';
import { Link as RouterLink } from 'react-router-dom';
import { useStorefrontState } from '../../../hooks/useReduxState';
import { getCartData } from '../../../store/actions/storefrontActions';
import { QuickOrderMastheadDescription } from '../QuickOrderTable/QuickOrderTable.styles';

const QuickOrderHeader = () => {
  const dispatch = useDispatch();
  const { cart, vendor } = useStorefrontState();
  const { selectedCart } = cart;
  const { logo, name, slug } = vendor;

  return (
    <Masthead
      actions={
        <Link
          asButton
          buttonStartIcon={<IconArrowLeft width={16} height={16} />}
          buttonVariant='secondary'
          component={RouterLink}
          onClick={() => {
            dispatch(
              getCartData({
                setIsLoading: true,
                slug,
                token: selectedCart.token,
              })
            );
          }}
          to={`/storefront/sellers/${slug}`}
        >
          Back to Storefront
        </Link>
      }
      title={
        <QuickOrderMastheadDescription>
          <img src={logo} alt={name} onError={handleImgSrcError} />
          <div>
            <Typography
              bodyStyle={bodySmallTypography}
              sx={{ color: neutral60.hex }}
            >
              Shopping with
            </Typography>
            <Typography
              bodyStyle={bodySmallTypography}
              sx={{ color: neutral60.hex, fontWeight: 600 }}
            >
              {name}
            </Typography>
          </div>
        </QuickOrderMastheadDescription>
      }
      testingId='quick-order-header--component--masthead'
    />
  );
};

export default QuickOrderHeader;
